import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { OnboardingData } from '../types';

interface OnboardingStore {
  sessionId: string | null;
  currentStep: number;
  data: Partial<OnboardingData>;
  
  // Actions
  setSessionId: (id: string) => void;
  setStep: (step: number) => void;
  updateData: (data: Partial<OnboardingData>) => void;
  resetOnboarding: () => void;
}

const initialData: Partial<OnboardingData> = {
  for_whom: null,
  help_type: null,
  concerns: [],
  optional_note: '',
  occupation_category: null,
  occupation_detail: null,
  province: 'AB',
  city: '',
  name: '',
  email: '',
  phone: '',
};

export const useOnboardingStore = create<OnboardingStore>()(
  persist(
    (set) => ({
      sessionId: null,
      currentStep: 1,
      data: initialData,

      setSessionId: (id) => set({ sessionId: id }),
      
      setStep: (step) => set({ currentStep: step }),
      
      updateData: (newData) => set((state) => ({
        data: { ...state.data, ...newData }
      })),
      
      resetOnboarding: () => set({
        sessionId: null,
        currentStep: 1,
        data: initialData
      })
    }),
    {
      name: 'mh-onboarding-storage',
      // Only persist essential data
      partialize: (state) => ({
        sessionId: state.sessionId,
        currentStep: state.currentStep,
        data: state.data
      })
    }
  )
);
